import { render, staticRenderFns } from "./begin.vue?vue&type=template&id=17a4b52c&scoped=true&"
import script from "./begin.vue?vue&type=script&lang=js&"
export * from "./begin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17a4b52c",
  null
  
)

export default component.exports